import { Dispatch, Middleware, MiddlewareAPI } from "redux";
import IStore from "../models/IStore";
import IAction from "../models/IAction";

const errorToastMiddleware = (): Middleware => (store: MiddlewareAPI<Dispatch, IStore>) => (next: Dispatch) => (
    action: IAction<any>
): void => {
    // if (action.error) {
    //     const errorAction = action as Required<IAction<IError>>;

    //     const errorObj = errorAction.payload.raw.data;
    //     const rootMsg = i18n.t("GLOBAL_SERVER_ERROR_" + errorObj?.code);

    //     next(ToastsAction.add(rootMsg, ToastStatusEnum.Error, JSON.stringify(errorObj)));
    // }

    // if(action.type === 'UserAction.REQUEST_LOGIN_USER_FINISHED' && !action.error){
    //     next(ToastsAction.add("Accesso effettuato correttamente", ToastStatusEnum.Success, ""));
    // }

    next(action);
};

export default errorToastMiddleware;
